import { eventBus } from "@/services-frontend/comment/eventBus";

/**
 * Bindings live at module scope and cannot reach React state, so anything that
 * has to drive a component emits through the app's event bus instead. Names are
 * centralised here so a binding and its listener cannot drift apart on a typo.
 */
export const SHORTCUT_EVENTS = {
  toggleSearch: "shortcut:toggle-search",
  findInPage: "shortcut:find-in-page",
} as const;

export function emitToggleSearch(): void {
  eventBus.emit(SHORTCUT_EVENTS.toggleSearch, undefined);
}

/**
 * Carries the focused editor so that with several mounted — page, peek panel,
 * sidebar — only that one opens its find bar. Null when focus is outside every
 * editor, which the main page bar treats as meant for it.
 */
export function emitFindInPage(editor: unknown): void {
  eventBus.emit(SHORTCUT_EVENTS.findInPage, { editor });
}
